import React from 'react';
import cn from 'classnames';

const Required = ({ value, children }) => {
  return value ? children : null;
};

export default Required;
